import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=5f633d0e&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=5f633d0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f633d0e",
  null
  
)

export default component.exports